import { initializeApp } from 'firebase/app'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'

const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// If Google Analytics is enabled, add the measurement ID to the config
if (import.meta.env.VITE_GOOGLE_ANALYTICS_ENABLED === 'true') {
  FIREBASE_CONFIG.measurementId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID
}

// Initialize Firebase and Firestore
export const firebaseApp = initializeApp(FIREBASE_CONFIG)

export const instance = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    cacheSizeBytes: 100 * 1024 * 1024, // 100 MB
    tabManager: persistentMultipleTabManager(),
  }),
})
